import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Pagination, Form, OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap';
import { FaSearch, FaEye } from 'react-icons/fa';
import apinode from '../../services/apinode';
import Navbar from '../../components/navbar/navbar.jsx';

const ItemList = () => {
    const [dataInicial, setDataInicial] = useState('');
    const [dataFinal, setDataFinal] = useState('');

    const [items, setItems] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [relatedOrders, setRelatedOrders] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingOrders, setLoadingOrders] = useState(false);
    const [error, setError] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(50);
    const [searchTerm, setSearchTerm] = useState('');

    // Adicionar um estado de busca no modal
    const [modalSearchTerm, setModalSearchTerm] = useState('');

    const [sortField, setSortField] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');
    const [filteredOrders, setFilteredOrders] = useState(relatedOrders);

    // Paginação para o modal de pedidos
    const [modalCurrentPage, setModalCurrentPage] = useState(1);
    const modalItemsPerPage = 50;

    const applyDateFilter = () => {
        if (!dataInicial || !dataFinal) {
            alert("Por favor, selecione as datas inicial e final para aplicar o filtro.");
            return;
        }

        const filteredItems = filteredOrders.filter((order) => {
            const orderDate = new Date(order.data);
            return orderDate >= new Date(dataInicial) && orderDate <= new Date(dataFinal);
        });

        setFilteredOrders(filteredItems); // Atualiza o estado com os itens filtrados
    };



    const handleSearchKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            applySearch();
        }
    };

    useEffect(() => {
        const fetchItems = async () => {
            setLoading(true);
            setError(null);

            try {
                const conta = localStorage.idconta;
                const response = await apinode.get(`/produtos/products-order/${conta}`);
                setItems(response.data);
                setFilteredItems(response.data);
            } catch (err) {
                console.error('Erro ao buscar SKUs:', err.message);
                setError('Não foi possível carregar a lista de SKUs. Tente novamente mais tarde.');
            } finally {
                setLoading(false);
            }
        };

        fetchItems();
    }, []);

    const applySearch = () => {
        const term = searchTerm.toLowerCase();

        const exactMatches = items.filter(
            (item) =>
                item.SKU.toLowerCase() === term ||
                item.DESCRICAO.toLowerCase() === term
        );

        const partialMatches = items.filter(
            (item) =>
                (item.SKU.toLowerCase().includes(term) ||
                    item.DESCRICAO.toLowerCase().includes(term)) &&
                !(item.SKU.toLowerCase() === term ||
                    item.DESCRICAO.toLowerCase() === term)
        );

        const filtered = [...exactMatches, ...partialMatches];
        setFilteredItems(filtered);
        setCurrentPage(1);
        setSortField('');
    };

    const sortItems = (field) => {
        const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
        setSortField(field);
        setSortOrder(order);

        const sortedItems = [...filteredItems].sort((a, b) => {
            if (a[field] < b[field]) return order === 'asc' ? -1 : 1;
            if (a[field] > b[field]) return order === 'asc' ? 1 : -1;
            return 0;
        });

        setFilteredItems(sortedItems);
    };

    const totalItems = filteredItems.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleItemClick = async (item) => {

        console.log(item)
        setSelectedItem(item);
        setShowModal(true);
        setLoadingOrders(true);
        setError(null);

        try {
            const response = await apinode.get(
                `/produtos/products-order-details/${localStorage.idconta}`,
                {
                    params: {
                        sku: item.SKU,
                        dataFin: dataFinal,
                        dataIn: dataInicial
                    }
                }
            );
            setFilteredOrders(response.data);
        } catch (err) {
            console.error('Erro ao buscar pedidos:', err.message);
            setError('Não foi possível carregar os pedidos. Tente novamente mais tarde.');
        } finally {
            setLoadingOrders(false);
        }
    };

    const handleItemModal = async (item) => {
        setSelectedItem(item);
        setShowModal(true);
        setLoadingOrders(true);
        setError(null);

        try {
            const response = await apinode.get(
                `/produtos/products-order-details/${localStorage.idconta}`,
                {
                    params: {
                        sku: item.SKU,
                        dataFin: dataFinal,
                        dataIn: dataInicial
                    }
                }
            );
            setFilteredOrders(response.data);
        } catch (err) {
            console.error('Erro ao buscar pedidos:', err.message);
            setError('Não foi possível carregar os pedidos. Tente novamente mais tarde.');
        } finally {
            setLoadingOrders(false);
        }
    };

    // Função para aplicar o filtro dentro do modal
    const applyModalSearch = () => {
        const term = modalSearchTerm.trim().toLowerCase();

        const filteredOrders = relatedOrders.filter((order) => {
            const pedido = order.pedido ? order.pedido.toString().toLowerCase() : '';
            const cliente = order.cliente ? order.cliente.toString().toLowerCase() : '';

            return pedido.includes(term) || cliente.includes(term);
        });

        setFilteredOrders(filteredOrders); // Defina um estado separado para pedidos filtrados se necessário
        setModalCurrentPage(1); // Reseta para a primeira página dos pedidos filtrados
    };


    const handleModalSearchKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            applyModalSearch();
        }
    };

    const modalTotalItems = filteredOrders.length;
    const modalTotalPages = Math.ceil(modalTotalItems / modalItemsPerPage);
    const modalIndexOfLastItem = modalCurrentPage * modalItemsPerPage;
    const modalIndexOfFirstItem = modalIndexOfLastItem - modalItemsPerPage;
    const modalCurrentItems = filteredOrders.slice(modalIndexOfFirstItem, modalIndexOfLastItem);

    const handleModalPageChange = (pageNumber) => {
        setModalCurrentPage(pageNumber);
    };

    return (
        <>
            <Navbar />
            <div className="mt-page">
                <h2>Lista de Itens</h2>

                {loading && <p>Carregando itens...</p>}
                {error && <p className="text-danger">{error}</p>}

                <Form className="mb-3 d-flex justify-content-between align-items-center">
                    <Form.Group controlId="searchTerm" className="flex-grow-1 me-3">
                        <Form.Label>Busca</Form.Label>
                        <div className="d-flex">
                            <Form.Control
                                type="text"
                                placeholder="Digite o nome ou SKU..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                onKeyDown={handleSearchKeyPress}
                            />
                            <Button variant="primary" onClick={applySearch} className="ms-2">
                                <FaSearch />
                            </Button>
                        </div>
                    </Form.Group>

                    <Form.Group controlId="itemsPerPage">
                        <Form.Label>Itens por página</Form.Label>
                        <Form.Control as="select" value={itemsPerPage} onChange={handleItemsPerPageChange}>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={200}>200</option>
                            <option value={500}>500</option>
                        </Form.Control>
                    </Form.Group>
                </Form>

                {currentItems.length > 0 && (
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th onClick={() => sortItems('DESCRICAO')}>Nome {sortField === 'DESCRICAO' && (sortOrder === 'asc' ? '▲' : '▼')}</th>
                                <th onClick={() => sortItems('SKU')}>SKU {sortField === 'SKU' && (sortOrder === 'asc' ? '▲' : '▼')}</th>
                                <th>Ação</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.map((item) => (
                                <tr key={item.SKU}>
                                    <td>{item.DESCRICAO}</td>
                                    <td>{item.SKU}</td>
                                    <td>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip>Ver pedidos</Tooltip>}
                                        >
                                            <Button
                                                variant="link"
                                                onClick={() => handleItemClick(item)}
                                                className="p-0 text-decoration-none"
                                            >
                                                <FaEye />
                                            </Button>
                                        </OverlayTrigger>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}

                {totalPages > 1 && (
                    <Pagination className="justify-content-center">
                        <Pagination.First
                            disabled={currentPage === 1}
                            onClick={() => handlePageChange(1)}
                        />
                        <Pagination.Prev
                            disabled={currentPage === 1}
                            onClick={() => handlePageChange(currentPage - 1)}
                        />
                        {[...new Set([1, Math.max(1, currentPage - 1), currentPage, Math.min(totalPages, currentPage + 1), totalPages])].filter((page) => page > 0 && page <= totalPages).sort((a, b) => a - b).map((page, index, array) => (
                            <React.Fragment key={page}>
                                {index > 0 && page > array[index - 1] + 1 && <Pagination.Ellipsis disabled />}
                                <Pagination.Item
                                    active={page === currentPage}
                                    onClick={() => handlePageChange(page)}
                                >
                                    {page}
                                </Pagination.Item>
                            </React.Fragment>
                        ))}

                        <Pagination.Next
                            disabled={currentPage === totalPages}
                            onClick={() => handlePageChange(currentPage + 1)}
                        />
                        <Pagination.Last
                            disabled={currentPage === totalPages}
                            onClick={() => handlePageChange(totalPages)}
                        />
                    </Pagination>
                )}
                <Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName="custom-modalzpl">
                    <Modal.Header closeButton>
                        <Modal.Title>Pedidos para {selectedItem?.DESCRICAO}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* Campo de Busca no Modal */}
                        <Form.Group controlId="modalSearchTerm">
                            <Form.Label>Busca de pedidos</Form.Label>
                            <div className="d-flex">
                                <Form.Control
                                    type="text"
                                    placeholder="Digite o número do pedido ou cliente..."
                                    value={modalSearchTerm}
                                    onChange={(e) => setModalSearchTerm(e.target.value)}
                                    onKeyDown={handleModalSearchKeyPress}
                                />
                                <Button variant="primary" onClick={applyModalSearch} className="ms-2">
                                    <FaSearch />
                                </Button>
                            </div>
                        </Form.Group>

                        {/* Filtro por Data */}
                        <Form.Group controlId="filterByDate" className="mt-3">
                            <Form.Label>Filtrar por data</Form.Label>
                            <div className="d-flex">
                                <Form.Control
                                    type="date"
                                    value={dataInicial}
                                    onChange={(e) => setDataInicial(e.target.value)}
                                />
                                <span className="mx-2 align-self-center">até</span>
                                <Form.Control
                                    type="date"
                                    value={dataFinal}
                                    onChange={(e) => setDataFinal(e.target.value)}
                                />
                                <Button
                                    variant="primary"
                                    onClick={() => handleItemClick(selectedItem)}
                                    className="ms-2"
                                >
                                    Filtrar
                                </Button>

                            </div>
                        </Form.Group>

                        {loadingOrders ? (
                            <div className="d-flex justify-content-center align-items-center">
                                <Spinner animation="border" />
                            </div>
                        ) : error ? (
                            <p className="text-danger">{error}</p>
                        ) : modalCurrentItems.length > 0 ? (
                            <>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Pedido</th>
                                            <th>Cliente</th>
                                            <th>Quantidade</th>
                                            <th>Valor (R$)</th>
                                            <th>Data</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {modalCurrentItems
                                            .sort((a, b) => new Date(b.data) - new Date(a.data)) // Ordenação por data decrescente
                                            .map((order) => (
                                                <tr key={order.pedido}>
                                                    <td>{order.pedido}</td>
                                                    <td>{order.cliente}</td>
                                                    <td>{order.quantidade?.toFixed(2)}</td>
                                                    <td>{order.valor_novo?.toFixed(2)}</td>
                                                    <td>{new Date(order.data).toLocaleDateString('pt-BR')}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </Table>


                                {/* Soma das Quantidades */}
                                <div className="mt-3 text-end">
                                    <strong>Total Quantidades: </strong>
                                    {filteredOrders.reduce((acc, order) => acc + (order.quantidade || 0), 0).toFixed(2)}

                                </div>

                                <Pagination className="justify-content-center">
                                    <Pagination.First
                                        disabled={modalCurrentPage === 1}
                                        onClick={() => handleModalPageChange(1)}
                                    />
                                    <Pagination.Prev
                                        disabled={modalCurrentPage === 1}
                                        onClick={() => handleModalPageChange(modalCurrentPage - 1)}
                                    />
                                    {[...new Set([1, Math.max(1, modalCurrentPage - 1), modalCurrentPage, Math.min(modalTotalPages, modalCurrentPage + 1), modalTotalPages])]
                                        .filter((page) => page > 0 && page <= modalTotalPages)
                                        .sort((a, b) => a - b)
                                        .map((page, index, array) => (
                                            <React.Fragment key={page}>
                                                {index > 0 && page > array[index - 1] + 1 && <Pagination.Ellipsis disabled />}
                                                <Pagination.Item
                                                    active={page === modalCurrentPage}
                                                    onClick={() => handleModalPageChange(page)}
                                                >
                                                    {page}
                                                </Pagination.Item>
                                            </React.Fragment>
                                        ))}
                                    <Pagination.Next
                                        disabled={modalCurrentPage === modalTotalPages}
                                        onClick={() => handleModalPageChange(modalCurrentPage + 1)}
                                    />
                                    <Pagination.Last
                                        disabled={modalCurrentPage === modalTotalPages}
                                        onClick={() => handleModalPageChange(modalTotalPages)}
                                    />
                                </Pagination>
                            </>
                        ) : (
                            <p>Nenhum pedido encontrado para este item.</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>

            </div>
        </>
    );
};

export default ItemList;
